module.exports = __webpack_public_path__ + "img/IR.e1e25f7f.svg";